import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdPushSettingsCacheKeys: AllRouteEndpoints[] = ["/engagement/:app_group_id/push_settings"];
